package net.bothosting.docs.pages.troubleshooting

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initInvalid_elf_headerPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("troubleshooting/invalid_elf_header.md", FrontMatterElement.EmptyMap))
}

@Page("/troubleshooting/invalid-elf-header")
@Layout(".components.layouts.DocsLayout")
@Composable
fun Invalid_elf_headerPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("invalid-elf-header") }) {
        org.jetbrains.compose.web.dom.Text("Invalid ELF Header")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This issue usually originates from the ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("node_modules")
        }
        org.jetbrains.compose.web.dom.Text(" folder. To resolve it, delete that folder and let your package file download the modules again.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.TIP, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" Please keep in mind that your ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("package.json")
            }
            org.jetbrains.compose.web.dom.Text(" file is required to regenerate the folder, and the ")
            org.jetbrains.compose.web.dom.Code {
                org.jetbrains.compose.web.dom.Text("node_modules")
            }
            org.jetbrains.compose.web.dom.Text(" folder should never be uploaded to the server.")
        }
    }
}
